export default
    {
        // url: this.$store.state.http.rhumanos.YYYY,
        guardaArchivo: "/rhumanos/guardaArchivo",
        list: "/rhumanos/list",

        listTipoDoc: "/rhumanos/listTipoDoc",
        listDocs: "/rhumanos/listDocs",
        getArchivo: "/rhumanos/getArchivo",

        getTurno: "/rhumanos/getTurno",
        getAreaLaboral: "/rhumanos/getAreaLaboral",
        getFuncionReal: "/rhumanos/getFuncionReal",
        getRelacionLaboral: "/rhumanos/getRelacionLaboral",

        guardaTrabajador: "/rhumanos/guardaTrabajador",

        guardaSubordinado: "/rhumanos/guardaSubordinado",
        listSubordinados: "/rhumanos/listSubordinados",

        buscaCurp: "/rhumanos/buscaCurp",

        guardaEncuestas: "/rhumanos/guardaEncuestas",
        listEncuestas: "/rhumanos/listEncuestas",

        guardaPerfil: "/rhumanos/guardaPerfil",
        listPerfil: "/rhumanos/listPerfil",

        guardaCurso: "/rhumanos/guardaCurso",
        listCurso: "/rhumanos/listCurso",
        listCursosPersona: "/rhumanos/listCursosPersona",
        editAsistentes: "/rhumanos/editAsistentes",

        printDc3:'/rhumanos/printDc3',
        printListaAsistencia:'printListaAsistencia',

        guardaTrabajadorRol:'/rhumanos/guardaTrabajadorRol',
        listTrabajadorRol:'/rhumanos/listTrabajadorRol',

        guardaIncidencia:'/rhumanos/guardaIncidencia',
        getIncidencia:'/rhumanos/getIncidencia',
    }
